import { EXPENSE_CONST } from '../actionConstants';
import { formatExpnsCatList, formatMyBizExpenseList } from '../../expense/components/AddEditExpense/utils';
import { noBookingData } from '../../expense/config';
import { PATHS, APPLICATION_CONSTANTS } from '../../AppConstants';
import { getccbAxiosConfig } from '../../apisSetup/ccbConfig';
import { getUUID, saveServerLogs } from '../../UtilityComponents/Util';

const axiosApiCaller = getccbAxiosConfig(true, {
    [APPLICATION_CONSTANTS.DEVICE_TYPE_KEY] : APPLICATION_CONSTANTS.DEVICE_TYPE,
    }, false);

export const setApiLoading = (state, isPopup, data, apiType ) => {
    return ({
        type: EXPENSE_CONST.API_LOADING,
        payload: {
            loading: state,
            isPopup,
            data,
            apiType,
        }
    })
}

export const setApiError = (data) => {
    return ({
        type: EXPENSE_CONST.API_ERROR,
        payload: { data }
    })
}

export const setApiSuccess = (data) => {
    return ({
        type: EXPENSE_CONST.API_SUCCESS,
        payload: { data }
    })
}

export const resetApiState = () => {
    return ({
        type: EXPENSE_CONST.RESET_API_STATE,
    })
}

export const setModal = (modalType) => ({
    type: EXPENSE_CONST.EXPNS_MODAL,
    payload: {
        modalType
    }
})

export const changeModalStep = (step) => {
    return ({
        type: EXPENSE_CONST.EXPNS_MODAL_STEP,
        payload: step,
    })
}

export const fetchExpnsCategory = ({loadingStep, successStep, failStep}) => async (dispatch) => {
    loadingStep && dispatch(changeModalStep(loadingStep));
    let isError = false;
    try {
        const resp = await axiosApiCaller.get(PATHS.EXPENSE_CATEGORY);
        const { data } = resp || {}
        if (data && data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
            const payload = formatExpnsCatList(data);
            dispatch({
                type: EXPENSE_CONST.EXPENSE_CAT,
                payload
            })
        } else {
            isError = true;
        }     
        successStep && dispatch(changeModalStep(successStep));
    } catch(err) {
        isError = true;
		saveServerLogs(e.stack, 'error', PATHS.EXPENSE_CATEGORY);
    } finally {
        if (isError) {
            if (failStep) {
                dispatch(changeModalStep(failStep));
            } else {
                dispatch(setApiError());
            }
        }
    }
}

export const fetchMyBizExpnsList = ({loadingStep, successStep, failStep, pageNumber = 0}) => async (dispatch) => {
    loadingStep && dispatch(changeModalStep(loadingStep));
    let isError = false;
    try {
        const resp = await axiosApiCaller.post(PATHS.MY_BIZ_EXPNS_LIST, {
            limit: 10,
            pageNumber,
        });
        const { data } = resp || {}
        if (data && data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
            const {myBizBookings=[], nextPage=false} = data
            const myBizList = formatMyBizExpenseList(myBizBookings);
            if (myBizList.length === 0) {
                dispatch(setApiError(noBookingData));
            } else {
                dispatch({
                    type: EXPENSE_CONST.BIZ_EXPNS_LIST,
                    payload: {
                        myBizList,
                        nextPage
                    }
                })
                successStep && dispatch(changeModalStep(successStep));
            }    
        } else {
            isError = true;
        }     
    } catch (err) {
        isError = true;
		saveServerLogs(e.stack, 'error', PATHS.MY_BIZ_EXPNS_LIST);
    } finally {
        if (isError && pageNumber === 0) {
            if (failStep) {
                dispatch(changeModalStep(failStep));
            } else {
                dispatch(setApiError());
            }
        }
    }

}

export const saveReceipt = ({ reqData, fileIdentifier, expenseId }) => async (dispatch) => {
    let isError = false
    try {
        const formData = new FormData();
        formData.append('file', reqData.fileBlob, reqData.fileName)
        const resp = await axiosApiCaller.post(PATHS.EXPNS_RECEIPT_UPLD, formData, {
            params: {
                uuid: getUUID()
            },
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        const { data } = resp || {};
        if (data && data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
            const { imageUrl, id } = data;
            dispatch({
                type: EXPENSE_CONST.EXPNS_RECEIPT_URL,
                payload: {
                    name: fileIdentifier,
                    imageUrl,
                    expenseId,
                    error: false,
                    id,
                }
            })
        } else {
            isError = true;
        }
    } catch (err) {
        isError = true;
		saveServerLogs(e.stack, 'error', PATHS.MY_BIZ_EXPNS_LIST);
    } finally {
        if (isError) {
            dispatch({
                type: EXPENSE_CONST.EXPNS_RECEIPT_URL,
                payload: {
                    name: fileIdentifier,
                    imageUrl: '',
                    expenseId,
                    error: true,
                }
            })
        }
    }
}

export const clearEditModalData = () => ({
    type: EXPENSE_CONST.CLEAR_EDIT_MODAL_DATA
})
